import { useQuery } from '@tanstack/react-query';
import useUser from '../global/useUser';
import { getGiftCardsOverview } from '../../services/gift-cards';

function useGetGiftCardsOverview() {
  const { user } = useUser();

  const { data, isLoading, isFetching, isError, error, refetch } = useQuery({
    queryKey: ['gift-cards-overview', user?.business?.id],
    queryFn: async () =>
      getGiftCardsOverview({
        businessId: user!.business!.id!,
      }),
    enabled: !!user?.business?.id,
  });

  return {
    data,
    isLoading,
    isFetching,
    isError,
    error,
    refetch,
  };
}

export default useGetGiftCardsOverview;
